import axios from 'axios'

export const PaymentApi = {
    async ErrorDetail(groupCode,receiptCode){
        const response = await axios.post(`/api/payment/errordetail/${groupCode}/${receiptCode}`)
        return response
    },
    async List(data){
        const response = await axios.post('/api/payment/list',data)
        return response
    },
    async GetDetail(data){
        const response = await axios.get(`/api/payment/getpaymentdetail/${data}`)
        return response
    },
    async DateControlForInstallment(data){
        const response = await axios.post('/api/payment/datecontrolforinstallment',data)
        return response
    },
    async CreateResponsibleUserApproveRequest(data){
        const response = await axios.post('/api/payment/createresponsibleuserapproverequest',data)
        return response
    },
    async CreatePaymentRequest(data){
        const response = await axios.post('/api/payment/createpaymentrequest',data)
        return response
    },
    async GetReceipt(data){
        const response = await axios.get(`/api/payment/get/receipt/${data}`)
        return response
    },
    async CurrentDateTotalAmount(){
        const response = await axios.get('/api/payment/get/currentdate/totalamount')
        return response
    },
    async CurrentMonthTotalAmount(){
        const response = await axios.get('/api/payment/get/currentmonth/totalamount')
        return response
    },
    async SalesmanLastWeekPaymentStatusList(){
        const response = await axios.get('/api/payment/lastoneweekcustomeractions')
        return response
    },
    async SalesmanPaymentStatusList(){
        const response = await axios.get('/api/payment/salesmanpaymentstatuslist')
        return response
    },
    async ResponsibleUserPaymentStatusList(){
        const response = await axios.get('/api/payment/responsibleuserpaymentstatuslist')
        return response
    },
    async ApproveInstallment(data){
        const response = await axios.post(`/api/payment/approveinstallmentfromtable/${data}`)
        return response
    },
    async ApproveRequestAgain(data){
        const response = await axios.post(`/api/payment/approverequestagain/${data}`)
        return response
    },
    async PosnetCalculateData(data){
        const response = await axios.post(`/api/payment/posnet/calculateposnetdata`,data)
        return response
    },
    async PreparePayment(data){
        const response = await axios.post(`/api/payment/prepare`,data)
        return response
    },
    async DailyStatsByUser(data){
        const response = await axios.post(`/api/payment/dailystatsbyuser`,data)
        return response
    },
    async DailyStatsByUserTotalAmount(data){
        const response = await axios.post(`/api/payment/dailystatsbyusertotalamount`,data)
        return response
    },
    async GetFaturasizOdemeTalebiReport(month,year){
        const response = await axios.get(`/api/payment/get/faturasizodemetalebi/${month}/${year}`)
        return response
    },
    async GetFaturasizOdemeTalebiReportExcel(month,year){
        const response = await axios.get(`/api/payment/get/faturasizodemetalebi/excel/${month}/${year}`)
        return response
    },
   async CalculateAkbankHashData(data){
        const response = await axios.post('/api/payment/akbank/calculatehashdata',data)
        return response
    },
    async GetRandomNumberAkbank(length){
        let locLength = length;
        if (length < 1 || length  == null) {
            locLength = 128;
        }
        const response = await axios.get(`/api/payment/akbank/getrandomnumber/${locLength}`)
        return response
    },
    
    Error:{
        async PaymentErrorDetail(id){
            const response = await axios.get(`/api/payment/get/paymenterrordetail/${id}`)
            return response
        },
        async PaymentErrrors(data){
            const response = await axios.post('/api/payment/paymenterrorlist',data)
            return response
        },
        async SendPaymentError(id){
            const response = await axios.post(`/api/payment/sendpaymenterror/${id}`)
            return response
        }
    }
}